import React, { Component } from 'react';
import {
    Container,
    Card,
    CardHeader, CardBody,
    Input,
    Button,
    Row,
    Col,
    Collapse
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import CompanyContext from '../../auth/CompanyContext';

class ImportCompanies extends Component {
    static contextType = CompanyContext;

    constructor(props) {

        super(props);

        this.batchLimit = 100;

        this.state = {
            data: [],
            isDone: false,
            inputFile: '',
            error: '',
            open: (this.props.open !== undefined) ? this.props.open : false,
            notesCategories: [],
            incompleteCompanies: false,
            maxCompanyNumber: 0,
            results: null,
            replacementOption: 0
        };

        this.fieldMap = [
            { targetProp: "Company Name", sourceProp: "Company Name" },
            { targetProp: "Company Number", sourceProp: "Company Number" },
            { targetProp: "Address 1", sourceProp: "Address 1" },
            { targetProp: "Address 2", sourceProp: "Address 2" },
            { targetProp: "City", sourceProp: "City" },
            { targetProp: "State", sourceProp: "State" },
            { targetProp: "Postal Code", sourceProp: "Postal Code" },
            { targetProp: "Phone Number", sourceProp: "Phone Number", sourceAction: (v) => this.normalizePhone(v) },
            { targetProp: "Fax Number", sourceProp: "Fax Number", sourceAction: (v) => this.normalizePhone(v) },
            { targetProp: "Website", sourceProp: "Website" },
        ];

    }

    componentDidMount() {
        this.getNotesCategories();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    getNotesCategories = () => {
        fetch('/api/notesCategories/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                const dataWithIds = results.data.map(item => ({ ...item, uuid: this.uuid() }));

                const flatChildren = dataWithIds.flatMap(parent =>
                    (parent.children ?? []).map(child => ({
                        ...child,
                        parentUUID: parent.uuid,
                        parentType: parent.type,
                    }))
                );
                this.setState({
                    notesCategories: flatChildren
                });
            });
        return;
    }

    uuid = () => {
        const a = new Uint8Array(16); crypto.getRandomValues(a);
        a[6] = (a[6] & 0x0f) | 0x40; a[8] = (a[8] & 0x3f) | 0x80;
        return [...a].map((b, i) => (i === 4 || i === 6 || i === 8 || i === 10 ? '-' : '') + b.toString(16).padStart(2, '0')).join('');
    }

    normalizeNotesCategory = (input, inputCategory) => {
        if (!input) return [null, null];

        const category = this.state.notesCategories.find(item => item.type.toLowerCase() === inputCategory.toLowerCase());
        if (!category) return input;
        if (category.multiline && category.list) {
            const answerArray = input.split(',').map(item => item.trim());
            const newArray = [];
            answerArray.forEach(answer => {
                const foundList = category.list.find(item => item.description.toLowerCase() === answer.toLowerCase());
                if (foundList) {
                    newArray.push(foundList.ID)
                }
            })
            return [category.ID, { parent: category.parentUUID, value: newArray }];
        } else if (category.multiline && !category.list) {
            return [category.ID, { parent: category.parentUUID, value: input }];
        } else {
            const foundList = category.list.find(item => item.description.toLowerCase() === input.toLowerCase());
            if (foundList) {
                return [category.ID, { parent: category.parentUUID, value: String(foundList.ID) }];
            }
        }
        return [null, null];
    }

    normalizeDate = (input) => {
        if (!input) return null;

        // Case 1: Already in yyyy-mm-dd from <input type="date">
        const isoPattern = /^\d{4}-\d{2}-\d{2}$/;
        if (isoPattern.test(input)) return input;

        // Try to parse any common format
        const parsed = new Date(input);
        if (isNaN(parsed)) return null;

        // Format to yyyy-mm-dd
        const y = parsed.getFullYear();
        const m = String(parsed.getMonth() + 1).padStart(2, "0");
        const d = String(parsed.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    }

    normalizePhone = (input) => {
        if (!input) return null;

        // Remove all non-digit characters
        const digits = input.replace(/\D/g, "");

        // Handle 10-digit numbers (standard U.S.)
        if (digits.length === 10) {
            return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
        }

        // Handle leading 1 for country code
        if (digits.length === 11 && digits.startsWith("1")) {
            return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
        }

        // Otherwise invalid or unsupported format
        return input;
    }

    parseCSVLine = (line) => {
        const result = [];
        let currentField = "";
        let insideQuotes = false;

        for (let char of line) {
            if (char === '"' && insideQuotes) {
                insideQuotes = false; // Closing a quoted field
            } else if (char === '"' && !insideQuotes) {
                insideQuotes = true; // Opening a quoted field
            } else if (char === "," && !insideQuotes) {
                result.push(currentField); // End of field
                currentField = "";
            } else {
                currentField += char; // Append character to the current field
            }
        }

        result.push(currentField); // Add the last field
        return result.map((field) => (field.startsWith('"') && field.endsWith('"') ? field.slice(1, -1) : field)); // Remove surrounding quotes
    };

    handleUpload = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        this.setState({
            inputFile: file
        }, () => {
            const reader = new FileReader();

            reader.onload = (e) => {
                const text = e.target.result;

                const rows = text.split("\n").map((line) => {
                    return this.parseCSVLine(line); 
                });

                const [headers, ...dataRows] = rows;
                const data = dataRows.map((row) => {
                    return headers.reduce((acc, header, index) => {
                        acc[header.trim()] = row[index]?.trim();
                        return acc;
                    }, {});
                });

                let dataArray = [];
                data.forEach(item => {
                    let companyIndex = (dataArray.findIndex(companyArr => companyArr['Company Name'] === item['Company Name'] && companyArr['Company Number'] === item['Company Number']));
                    if (companyIndex === -1) {
                        const baseObj = this.fieldMap.reduce((acc, { targetProp, sourceProp, sourceAction }) => {
                            const raw = item[sourceProp];
                            const val = sourceAction ? sourceAction(raw) : raw;
                            if (
                                targetProp === 'Company Name' ||
                                targetProp === 'Company Number' ||
                                (val != null && val !== '')
                            ) {
                                acc[targetProp] = val;
                            }
                            return acc;
                        }, {});

                        Object.keys(item).forEach((key) => {
                            const exists = this.fieldMap.some(({ sourceProp }) => sourceProp === key);
                            if (!exists) {
                                const [newKey, newVal] = this.normalizeNotesCategory(item[key], key);
                                if (newKey) baseObj[newKey] = newVal;
                            }
                        });

                        baseObj.randomKey = Math.round(Math.random() * 100000000);
                        dataArray.push(baseObj);
                    }
                })
                this.setState({
                    data: dataArray,
                }, () => {
                    this.insertData(dataArray);
                })
            };
            reader.readAsText(file);
        })
    }

    insertData(dataArray, finish = false) {
        fetch('/api/import/companies/', {
            method: 'POST',
            body: JSON.stringify({
                data: dataArray,
                finish: finish,
                replacementOption: this.state.replacementOption
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results?.debug_message?.error != null) {
                    this.setState({
                        isDone: true,
                        error: 'Unable to fully process uploaded file'
                    })
                    return;
                };
                this.setState({
                    isDone: true,
                    maxCompanyNumber: results.maxCompanyNumber,
                    data: results.data,
                    incompleteCompanies: results.incompleteCompanies,
                    results: results.results
                })
            })
            .catch(reason => {
                this.setState({
                    isDone: true,
                    error: 'Unable to process uploaded file'
                })
            })

    }

    resetUpload = () => {
        this.setState({
            data: [],
            isDone: false,
            inputFile: '',
            error: '',
            incompleteCompanies: false,
            maxCompanyNumber: 0,
            results: null
        })
    }

    finishUpload = () => {
        this.insertData(this.state.data/*.filter(item => item['Company Number'] !== '' && item['Company Name'] !== '')*/, true)
    }

    changeIncompleteCompany = (value, randomKey, prop) => {
        this.setState((prev) => {
            const incompleteCompanies = prev.incompleteCompanies;
            const data = prev.data;
            const targetIC = incompleteCompanies.findIndex(item => item.randomKey === randomKey);
            const targetData = data.findIndex(item => item.randomKey === randomKey);
            incompleteCompanies[targetIC][prop] = value;
            data[targetData][prop] = value;
            return {
                data,
                maxCompanyNumber: prev.maxCompanyNumber,
                incompleteCompanies: incompleteCompanies
            }
        })
    }

    autoGenerate = (index, offset = 0) => {
        const max = (Number(this.state.maxCompanyNumber)) + offset + 10;
        if (this.state.data.findIndex(item => item['Company Number'] === `999-${max}`) > -1) return this.autoGenerate(index, offset + 10);
        this.setState((prev) => {
            const incompleteCompanies = prev.incompleteCompanies;
            incompleteCompanies[index]['Company Number'] = '999-' + max;
            const data = prev.data;
            const targetData = data.findIndex(item => item.randomKey === incompleteCompanies[index].randomKey);
            data[targetData]['Company Number'] = '999-' + max;
            return {
                data,
                maxCompanyNumber: max,
                incompleteCompanies: incompleteCompanies
            }
        })
    }

    showHide(element) {
        this.setState({
            open: !this.state.open
        })
    }

    render() {
        let duplicates = false;
        if (this.state.data) {
            duplicates = [...this.state.data].filter(item => item['Company Number'] !== '')
                .map(i => i['Company Number'])
                .filter((v, i, a) => a.indexOf(v) !== i);
        }
        return (
            <Container fluid>
                <Card>
                    <CardHeader onClick={() => this.showHide()}>
                        <Row className="align-items-center">
                            <Col className="col-md-11 text-left">
                                <h3>Import Companies</h3>
                            </Col>
                            <Col xs="1" className="text-right">
                                {(this.state.open) ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                            </Col>
                        </Row>
                    </CardHeader>
                    <Collapse isOpen={this.state.open}>
                        <CardBody>
                            {(!this.state.isDone) ?
                                <>
                                    <Row className="align-items-center">
                                        <Col className="col-md-6 text-left">
                                            <Input
                                                type="select"
                                                className='mb-4'
                                                name="replacementOption"
                                                onChange={e => this.setState({ replacementOption: parseInt(e.target.value) })}
                                                value={this.state.replacementOption}
                                            >
                                                <option value={0}>COMPANY OVERWRITE/MERGE DATA OPTIONS</option>
                                                <option value={1}>Ignore all custom columns, only overwrite primary fields</option>
                                                <option value={2}>Replace data only from uploaded columns (will erase any company changes or additions made in application)</option>
                                                <option value={3}>Remove and replace all old data (will erase any company changes or additions made in application)</option>
                                            </Input>
                                            <Input disabled={this.state.notesCategories.length === 0} type="file" name="file" accept='.csv' onChange={e => this.handleUpload(e)} value='' />
                                        </Col>
                                        <Col className="col-md-6 text-right">
                                            Imports companies .csv
                                            <p><a href="/crm-companies-template.csv" download>Download CSV Template</a></p>
                                        </Col>
                                    </Row>
                                </> : <></>
                            }
                            {this.state.error &&
                                <Row>
                                    <Col className="text-left text-danger">
                                        {this.state.error}
                                    </Col>
                                    <Col className="text-right">
                                        <Button color="primary" onClick={this.resetUpload}>Import Another</Button>
                                    </Col>
                                </Row>
                            }
                            {!this.state.results && this.state.incompleteCompanies &&
                                <Row>
                                    <Col className="text-left">
                                        <p>To complete importing companies, please identify any missing company information (entries without both fields will not be added):</p>
                                        <Row className='font-weight-bold'>
                                            <Col xs={6}>
                                                Company Name
                                            </Col>
                                            <Col>
                                                Company Number
                                            </Col>
                                        </Row>
                                        {this.state.incompleteCompanies.map((company, companyIndex) => (
                                            <Row className='mt-2' key={companyIndex}>
                                                <Col xs={6}>
                                                    <Input
                                                        className={duplicates.findIndex(item => item === company['Company Number']) > -1 ? "border border-danger"
                                                            : (this.state.incompleteCompanies[companyIndex]['Company Name'] !== '' && this.state.incompleteCompanies[companyIndex]['Company Number'] !== ''
                                                                ? 'border border-success' : '')}
                                                        onChange={(e) => this.changeIncompleteCompany(e.target.value, company.randomKey, 'Company Name')}
                                                        value={company['Company Name']}
                                                    />
                                                </Col>
                                                <Col className='pr-1'>
                                                    <Input
                                                        className={duplicates.findIndex(item => item === company['Company Number']) > -1 ? "border border-danger" :
                                                            (this.state.incompleteCompanies[companyIndex]['Company Name'] !== '' && this.state.incompleteCompanies[companyIndex]['Company Number'] !== ''
                                                                ? 'border border-success' : '')}
                                                        onChange={(e) => this.changeIncompleteCompany(e.target.value, company.randomKey, 'Company Number')}
                                                        value={company['Company Number']}
                                                    />
                                                </Col>
                                                <Col xs={2} className='pl-1'>
                                                    {company['Company Number'] === '' &&
                                                        <Button color="secondary" onClick={() => this.autoGenerate(companyIndex)}>Auto Generate</Button>}
                                                </Col>
                                            </Row>
                                        ))}
                                    </Col>
                                    <Col className="text-right" xs={2}>
                                        <Button disabled={duplicates.length > 0} color="primary" onClick={this.finishUpload}>Finish Import</Button>
                                    </Col>
                                </Row>
                            }
                            {this.state.results && !this.state.incompleteCompanies &&
                                <Row>
                                    <Col className="text-left">
                                        <p>Existing companies in database: <strong>{this.state.results?.matchedCompanies?.length || 0}</strong></p>
                                        <p>Companies with primary columns updated in database: <strong>{this.state.results?.rowsUpdated || 0}</strong></p>
                                        <p>New companies added to database: <strong>{(this.state.results?.unmatchedCompleteCompanies?.length || 0)}</strong></p>
                                        <p>Companies skipped (incomplete data): <strong>{(this.state.results?.unmatchedIncompleteCompanies?.length || 0)}</strong></p>
                                    </Col>
                                    <Col className="text-right">
                                        <Button color="primary" onClick={this.resetUpload}>Import Another</Button>
                                    </Col>
                                </Row>
                            }
                        </CardBody>
                    </Collapse>
                </Card>
            </Container>
        );
    }
}

export default ImportCompanies;